module.exports = {
    username: 'Username',
    password: 'Password',
    name: 'Name',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    phone: 'Phone',
    email: 'Email',
    search: 'Search through the table...',
    export: 'Export',
    forgotPass: 'Forgot your password?',
    rememberMe: 'Remember me',
    login: 'Login',
    registerNow: 'Register now',
    dontHaveAccount: 'Don’t have an account?',
    superadmin: 'Superadmin',
    user: 'User',
    userDetails: 'User details',
    address: 'Address',
    website: 'Website',
    logo: 'Logo',
    client: 'Client',
    roles: 'Roles',
    clients: 'Clients',
    profile: 'Profile',
    passwordConfirmation: 'Confirm password',
    clientsL: 'clients',
    usersL: 'users',
    of: 'of',
    smsSent: 'Sms Sent',
    homepage: 'Website',
    clientDetails: 'Client Details',
    location: 'Location',
    locationDetails: 'Location Details',
    locationName: 'Location name',
    street: 'Street',
    city: 'City',
    zipcode: 'Post code',
    country: 'Country',
    timezone: 'Time zone',
    locationEntrances: 'Location entrances',
    entrance1: 'Entrance 1',
    entrance2: 'Entrance 2',
    company: 'Company',
    domain: 'Domain',
    contactNumber: 'Phone number',
    emailAddress: 'Email address',
    companyLocations: 'Company locations',
    companyDetails: 'Company details',
    filterLocation: 'Filter by location',
    employeesL: 'employees',
    companiesL: 'companies',
    locationsL: 'locations',
    employee: 'employee',
    employeeDetails: 'Employee details',
    firstName: 'First name',
    lastName: 'Last name',
    personalDetails: 'Personal details',
    corporateDetails: 'Corporate details',
    gjestebokRole: 'Gjestebok role',
    isPrimaryContact: 'This person is the company primary contact',
    isDepartmentHost: 'This person is the department host',
    floor: 'Floor',
    jobTitle: 'Job title',
    department: 'Department',
    searchLocations: 'Search locations',
    searchCompanies: 'Search companies',
    entrance: 'Entrance',
    companiesInThisLocation: 'Companies in this location',
    device: 'device',
    devicesL: 'devices',
    devices: 'Devices',
    deviceName: 'Device name',
    deviceLocation: 'Device location',
    filterHost: 'Filter by host',
    filterDate: 'Filter by date',
    visitorDetails: 'Visitor details',
    host: 'Host',
    hostName: 'Host name',
    notifyHostSMS: 'Notify the host through SMS',
    chooseHost: 'Choose a host for the guest',
    invitationDetails: 'Invitation details',
    note: 'Note',
    additionalNotes: 'Write any additional notes here...',
    image: 'Image',
    todayDate: 'Today’s date',
    todayTime: 'Time now',
    date: 'Date',
    time: 'Time',
    admin: 'Admin',
    companies: 'Companies',
    guests: 'Guests',
    invites: 'Invites',
    visitors: 'Visitors',
    employees: 'Employees',
    locations: 'Locations',
    from: 'From',
    to: 'To',
    action: 'Action',
    allNone: 'All/None',
    first: 'First',
    last: 'Last',
    model: 'Model',
    default: 'Default',
    registeredOn: 'Registered on',
    lastModifiedOn: 'Last modified on',
    createdOn: 'Created on',
    modifiedOn: 'Modified on',
    hour: 'Hour',
    minute: 'Minute',
    mandatory: 'Mandatory',
    response: 'Response',
    notifications: 'Notifications',
    text: 'Text',
    themes: 'Themes',
    details: 'Details',
    download: 'Download',
    instance: 'Instance',
    backendversion: 'Backend',
    ipAddress: 'IP Address',
    portNumber: 'Port Number',
    changePassword: 'Change password',
    system: 'System',
    created: 'Created',
    updated: 'Updated',
    cancellation: 'Cancel',
    print: 'Print',
    register: 'Register',
    number: 'No',
    mode: 'Mode',
    dark: 'Dark',
    fontSizes: 'Font Sizes',
    theme: 'Themes',
    none: 'None',
    successful: 'Successful',
    open: 'Open',
    failed: 'Failed',
    activeOnly: 'Active Only',
    keyType: 'Key Type',
    payload: 'Payload',
    privateKey: 'Private Key',
    signatureAlgorithm: 'Signature Algorithm',
    url: 'Url',
    maxPoolSize: 'Max Pool Size',
    port: 'Port',
    sid: 'SID',
    token: 'Token',
    apiVersion: 'API Version',
    appId: 'APP ID',
    aud: 'AUD',
    id: 'ID',
    maxProcessingDurationInMSec: 'Max Processing Duration in MSec',
    maxProcessingDuration: 'Max Processing Duration',
    process: 'Process',
    triggerCondition: 'Trigger Condition',
    seconds: 'Seconds',
    minutes: 'Minutes',
    minutesInterval: 'Minutes Interval',
    hours: 'Hours',
    hoursInterval: 'Hours Interval',
    dayOfMonth: 'Day Of Month',
    month: 'Month',
    dayOfWeek: 'Day Of Week',
    method: 'Method',
    maxRequestSize: 'Max Request Size',
    frontEnd: 'Front end',
    searchByName: 'Search By Name',
    finishedOn: 'Finished On',
    startedOn: 'Started On',
    instanceId: 'Instance ID',
    eventId: 'Event ID',
    threadId: 'Thread ID',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    selectProcessFirst: 'Select process first',
    event: 'Event',
    exceptionMessage: 'Exception Message',
    exceptionStackTrace: 'Exception Stack Trace',
    stepId: 'Step ID',
    maxSimultaneousExecutions: 'Max Simultaneous Executions',
    saveProcessToEditSteps: 'Save Process To Edit Steps',
    defaultStepsName: 'Steps Name',
    properties: 'Properties',
    stepProperties: 'Step Properties',
    enabled: 'Step enabled',
    query: 'Query',
    targetObject: 'Target Object',
    credential: 'Credential',
    recordName: 'Record Name',
    triggerId: 'Trigger ID',
    type: 'Type',
    processingStartOn: 'Processing started on',
    showCache: 'Cache',
    list: 'List',
    json: 'JSON',
    async: 'Asynchronous execution',
    input: 'Input',
    output: 'Output',
    js: 'JavaScript',
    switch: 'Switch',
    collectionName: 'Collection Name',
    queryUpdate: 'Query Update',
    mailTemplate: 'Mail Template',
    variables: 'Variables',
    subject: 'Subject',
    restResponseCode: 'REST response code target object',
    targetUrl: 'Target Url',
    timeout: 'Timeout in MSec',
    body: 'Body',
    headers: 'Headers',
    queryParams: 'Query Params',
    channelId: 'Channel ID',
    message: 'Message',
    logsTtlInMSec: 'Time-to-live for logs',
    stepName: 'Step Name',
    copy: 'Copy',
    steps: 'Steps',
    filter: 'Filter',
    step: 'Step',
    childStep: 'Child Step',
    permissions: 'Permissions',
    code: 'Code',
    assignable: 'Assignable',
    yes: 'Yes',
    no: 'No',
    textTemplate: 'Text Template',
    en: 'English',
    de: 'Deutsch',
    language: 'Language',
    connectionTimeout: 'Connection Timeout',
    writeTimeout: 'Write Timeout',
    template: 'Template',
    grant_type: 'Grant type',
    refresh_token: 'Refresh token',
    setPasswordUrl: 'Set Password Url',
    maxTriggerHttpThreads: 'Max Trigger Http Threads',
    maxTriggerHttpProcessingInMSec: 'Max Trigger Http Processing Duration',
    maxProcessingThreads: 'Max Processing Threads',
    permissionType: 'Permission Type',
    unit: 'Unit',
    changeableTimeout: 'Timeout',
    secondsInterval: 'Seconds Interval',
    account: 'Account',
    yourAccount: 'Your Account',
    setPassword: 'Set Password',
    confirmPassword: 'Confirm Password',
    baseUrlRest: 'Base Url Rest',
    stepType: 'Step Type',
    gdpr: 'GDPR Relevant',
    history: 'History',
    notSet: 'Not set',
    defaultLocale: 'Default Locale',
    global: 'Global',
    local: 'Local',
    est: 'Trace',
    addProcessName: 'Add Process Name',
    visualId: 'Visual ID',
    bg: 'Bulgarian',
    zh: 'Chinese (Simplified)',
    hr: 'Croatian',
    cs: 'Czech',
    da: 'Danish',
    nl: 'Dutch',
    et: 'Estonian',
    fi: 'Finnish',
    fr: 'French',
    el: 'Greek',
    hu: 'Hungarian',
    ga: 'Irish',
    it: 'Italian',
    lv: 'Latvian',
    lt: 'Lithuanian',
    mt: 'Maltese',
    pl: 'Polish',
    pt: 'Portuguese',
    ro: 'Romanian',
    ru: 'Russian',
    sr: 'Serbian',
    sk: 'Slovak',
    sl: 'Slovene',
    es: 'Spanish',
    sv: 'Swedish',
    tr: 'Turkish',
    uk: 'Ukrainian',
    validation: 'Validation',
    permission: 'Permission',
    exist: 'Exist',
    missingParams: 'Missed Required Resources',
    fileLoaded: 'File Loaded',
    scriptEngine: 'Script Engine',
    dataType: 'Data Type',
    ruleType: 'Rule Type',
    fields: 'Fields',
    fieldName: 'Field Name',
    required: 'Required',
    rules: 'Rules',
    field: 'Field',
    rule: 'Rule',
    validationRules: 'Validation Rules',
    logServerUrl: 'Log Server Url',
    logs: 'Logs',
    apiKey: 'Api Key',
    listOfCodes: 'List of HTTP codes',
    logsServer: 'Log Server',
    debug: 'Debug',
    processSettingName: 'Setting',
    UPLOAD: 'Upload',
    DOWNLOAD: 'Download',
    descriptions: 'Descriptions',
    loadDirection: 'Load Direction',
    encrypt: 'Encrypt',
    restResponseContentTargetObject: 'REST response content target object',
    enableStepLog: 'Logging',
    urlForAdmin: 'Healthcheck URL for admin',
    urlForProcessingService: 'Healthcheck URL for the processing service',
    searchByModuleName: 'Search by Module Name',
    description: 'Description',
    basicAccessAuthentication: 'Allow Basic Authentication',
    upDownload: 'Up/Download',
    remoteId: 'Remote Id',
    exception: 'Exception',
    className: 'Class Name',
    checksum: 'Checksum',
    stepTypes: 'Step Types',
    plugin: 'Plugin',
    selectPlugin: 'Select Plugin First',
    processLogs: 'Process logs',
    openProcessLogs: 'Open logs',
    accessKeyId: 'Access Key Id',
    region: 'Region',
    s3Bucket: 'S3 Bucket',
    secretKey: 'Secret Key',
    content: 'Content',
    key: 'Key',
    path: 'Path',
    events: 'Events',
    backEnd: 'Back end',
    isCacheStepLogsEnabled: 'Cache storage',
    isStepLogsEnabled: 'Logging',
    enableCacheLog: 'Cache storage',
    tos: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    passphrase: 'Passphrase',
    queryConsole: 'Query Console',
    console: 'Console',
    affectedRows: 'Affected Rows',
    success: 'Success',
    respondSent: 'Respond sent',
    resultDetails: 'Result Details',
    engine: 'Engine',
    isBodyScript: 'Body Script',
    groovy: 'Groovy',
    last15MinutesCount: 'Last 15 minutes',
    last24HoursCount: 'Last 24 hours',
    last60MinutesCount: 'Last 60 minutes',
    todayCount: 'Today',
    executions: 'Executions',
    eventStates: 'Events states',
    childEventIdPath: 'Child event ID target object',
    folder: 'Folder',
    sizeInBytes: 'Size In Bytes',
    readType: 'Read Type',
    maxResults: 'Max Results',
    recipient: 'Recipient',
    sender: 'Sender',
    emailId: 'Email Id',
    locale: 'Locale',
    heartbeat: 'Heartbeat',
    overview: 'Overview',
    review: 'Review',
    title: 'Title',
    rating: 'Rating',
    reviews: 'Reviews',
    submitReview: 'Submit Review',
    metricServerUrl: 'Metric Server Url',
    visualisationServerUrl: 'Visualisation Server Url',
    metricServer: 'Metric Server',
    visualisationServer: 'Visualisation Server',
    internalJobs: 'Internal jobs',
    started: 'Started',
    hideChildren: 'Hide children',
    showChildren: 'Show children',
    diagrams: 'Diagrams',
    genericSubType: 'Member type',
    userId: 'User ID',
    filters: 'Filters',
    source: 'Source Object',
    attachments: 'Attachments',
    showAttachments: 'Show attachments',
    contentType: 'Content type',
    includeHeaders: 'Include headers in output',
    openProcessEvents: 'Open events',
    validations: 'Validations',
    allowQueryConsole: 'Allow usage of Query Console',
    stats: 'Statistics',
    available: 'Available',
    used: 'Used',
    processing: 'Processing',
    http: 'Http',
    threadStatistics: 'Thread statistics',
    lastUpdateHeartbeat: 'Last update/Heartbeat',
    delimiter: 'Delimiter',
    qualifier: 'Qualifier',
    customDelimiter: 'Custom delimiter',
    cc: 'CC',
    bcc: 'BCC',
    singleResult: 'Single result',
    saveToAddImage: 'Save user to add image',
    baseUrl: 'Base url',
    base_url: 'Base url',
    wc_consumer_key: 'Consumer key',
    wc_consumer_secret: 'Consumer secret',
    wp_client_id: 'Client id',
    wp_client_secret: 'Client secret',
    is_active: 'Active',
    products: 'Products',
    noSkuOnly: 'No SKU only',
    categories: 'Categories',
    showDescription: 'Show description',
    defaultProduct: 'Default product',
    stockStatus: 'Stock status',
    site: 'Site',
    sku: 'SKU',
    sites: 'Sites',
    short_description: 'Short description',
    skuReadOnly: 'SKU (read only)',
    media: 'Media',
    permalinkReadOnly: 'Permalink (read only)',
    slug: 'Slug',
    stock_status: 'Stock status',
    slugReadOnly: 'Slug (read only)',
    regular_price: 'Regular price',
    price: 'Price',
    price_html: 'Price html',
    searchBySku: 'Search by SKU',
    connectedProducts: 'Connected products',
    sales_price: 'Sales price',
    imageName: 'Image name',
    imageAlt: 'Image alt',
    featured: 'Featured',
    addToSites: 'Add to sites',
    connections: 'Connections',
    sale_price: 'Sale price',
    wysiwyg: 'WYSIWYG',
    images: 'Images',
};
